import { MfaMethod } from '@shared/services';

const KNOWN_METHODS = new Set<string>([MfaMethod.PASSKEY, MfaMethod.TOTP, MfaMethod.EMAIL]);

/** Drops any method the client does not know how to render (untrusted server/history-state input). */
export const filterKnownMfaMethods = (methods: string[]): MfaMethod[] =>
  methods.filter((method): method is MfaMethod => KNOWN_METHODS.has(method));
